import React from 'react';
import { FormikProps } from 'formik';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

import AppFormSelectWrapper from '../../../../components/designe/app-form-select-wrapper';
interface Props {
  formik: FormikProps<any>;
  filterActiveOptions: Array<{ id: string | boolean; name: string }>;
  categoryOptions: Array<{ id: string; name: string }>;
  preferenceOptions: Array<{ id: string; name: string }>;
}

export function NotificationTemplatesFilter(props: Props) {
  const { formik, filterActiveOptions, categoryOptions, preferenceOptions } =
    props;
  const { t } = useTranslation();

  return (
    <Grid container spacing={1}>
      <Grid item sm={4}>
        <AppFormSelectWrapper
          label={t('common.active')}
          name="active"
          options={filterActiveOptions}
          disableClear={false}
          formik={formik}
        />
      </Grid>
      <Grid item sm={4}>
        <AppFormSelectWrapper
          label={t('adminDashboard.notifications.templates.category')}
          name="category"
          options={categoryOptions}
          disableClear={false}
          formik={formik}
        />
      </Grid>
      <Grid item sm={4}>
        <AppFormSelectWrapper
          label={t('adminDashboard.notifications.templates.preferenceGroup')}
          name="preferenceGroup"
          options={preferenceOptions}
          disableClear={false}
          formik={formik}
        />
      </Grid>
    </Grid>
  );
}
